import axios from 'axios'
import * as HttpStatus from 'http-status-codes'
import { Identifier } from 'react-admin'

export const getCTXLoad = (refId: Identifier) => {
  const url = `/api/v1/console/ctx-loads/?human_id=${refId}`
  return axios.get(url).then((response) => {
    if (response.status === HttpStatus.OK) {
      return response.data?.results
    }
  })
}
